/* The Linen Room product gallery
   - shows only the selected colour's photos (metafield custom.kleur_media, served by templates/product.kleurmedia.liquid;
     fallback: photos whose alt text ends with the colour name)
   - every thumbnail is clickable and becomes the large photo
   - clicking the large photo opens an on-page zoom viewer (full resolution, click/tap to zoom, arrows, swipe, Esc) */
function TT(k, d) { return (window.TLR_T && window.TLR_T[k]) || d; }
(function () {
  "use strict";
  var root = document.querySelector("[data-product-root]");
  var gal = document.querySelector(".pdp-gal");
  var main = gal && gal.querySelector(".g-main");
  if (!root || !main) return;

  var css = document.createElement("style");
  css.textContent =
    ".pdp-gal .g-main{cursor:zoom-in}" +
    ".pdp-gal .g-sm{cursor:pointer;position:relative}" +
    ".pdp-gal .g-sm.is-active::after{content:'';position:absolute;inset:0;box-shadow:inset 0 0 0 2px currentColor;pointer-events:none}" +
    ".pdp-gal .g-sm:hover img{opacity:.85}" +
    ".pdp-gal .g-zoom-hint{position:absolute;right:12px;bottom:12px;background:rgba(255,255,255,.9);font-size:11px;letter-spacing:.08em;text-transform:uppercase;padding:6px 10px;pointer-events:none}" +
    ".pdp-gal .g-main{position:relative}" +
    ".tlr-lb{position:fixed;inset:0;z-index:2147483000;background:rgba(250,249,245,.98);display:none;align-items:center;justify-content:center;overflow:hidden;touch-action:none}" +
    ".tlr-lb.open{display:flex}" +
    ".tlr-lb-stage{position:absolute;inset:56px 64px;display:flex;align-items:center;justify-content:center;overflow:hidden}" +
    ".tlr-lb img{max-width:100%;max-height:100%;object-fit:contain;cursor:zoom-in;transition:transform .25s ease;transform-origin:center center;user-select:none;-webkit-user-drag:none}" +
    ".tlr-lb.zoomed img{cursor:zoom-out;transition:none}" +
    ".tlr-lb button{position:absolute;background:transparent;border:0;color:#1c2a22;cursor:pointer;font:300 34px/1 serif;padding:12px 16px;z-index:2}" +
    ".tlr-lb .lb-x{top:8px;right:12px}" +
    ".tlr-lb .lb-p{left:8px;top:50%;transform:translateY(-50%)}" +
    ".tlr-lb .lb-n{right:8px;top:50%;transform:translateY(-50%)}" +
    ".tlr-lb .lb-c{position:absolute;bottom:18px;left:0;right:0;text-align:center;font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#1c2a22}" +
    "@media (max-width:900px){.tlr-lb-stage{inset:52px 8px 48px}.tlr-lb .lb-p,.tlr-lb .lb-n{display:none}}" +
    "html.tlr-lb-lock{overflow:hidden}";
  document.head.appendChild(css);

  var path = window.location.pathname.replace(/\/$/, "");
  fetch(path + "?view=kleurmedia", { credentials: "same-origin" })
    .then(function (r) { return r.json(); })
    .then(init)
    .catch(function () {});

  function init(data) {
    var media = (data.media || []).filter(Boolean);
    if (!media.length) return;
    var byId = {};
    media.forEach(function (m) { byId[String(m.id)] = m; });

    var mainImg = main.querySelector("img");
    var mainSizes = (mainImg && mainImg.getAttribute("sizes")) || "(max-width: 900px) 100vw, 55vw";
    var firstSm = gal.querySelector(".g-sm");
    var smClass = (firstSm ? firstSm.getAttribute("class") : "g-sm").replace(/\s*is-active/g, "");
    function norm(s) { return String(s || "").trim().toLowerCase(); }

    // Colour option (if any)
    var colourInputs = root.querySelectorAll(".swatches input[type=radio]");
    var optName = colourInputs.length ? colourInputs[0].name : null;
    var colours = Array.prototype.map.call(colourInputs, function (i) { return i.value; });

    // colour -> photos
    var groups = {}, shared = [], map = data.map;
    if (optName) {
      if (map && typeof map === "object") {
        Object.keys(map).forEach(function (k) {
          var list = (map[k] || []).map(function (id) { return byId[String(id)]; }).filter(Boolean);
          if (k === "*") shared = list; else groups[norm(k)] = list;
        });
      } else {
        media.forEach(function (m) {
          var a = norm(m.alt);
          colours.forEach(function (c) {
            var n = norm(c);
            if (n && a && (a === n || a.slice(-(n.length + 1)) === " " + n)) (groups[n] = groups[n] || []).push(m);
          });
        });
      }
    }
    var byColour = Object.keys(groups).length >= 2;

    function makeImg(m, big, eager) {
      var el = document.createElement("img");
      el.src = big ? m.src : m.src7;
      el.srcset = m.src7 + " 700w, " + m.src + " 1400w";
      el.sizes = big ? mainSizes : "(max-width: 900px) 50vw, 27vw";
      el.alt = m.alt || "";
      el.width = 1400;
      el.height = Math.round(1400 / (m.ar || 1));
      if (eager) el.setAttribute("fetchpriority", "high"); else el.loading = "lazy";
      return el;
    }

    var list = [], active = 0;
    function setMain(i) {
      var m = list[i];
      if (!m) return;
      active = i;
      main.innerHTML = "";
      main.appendChild(makeImg(m, true, true));
      var hint = document.createElement("span");
      hint.className = "g-zoom-hint";
      hint.textContent = TT("zoom_hint", "Klik om te vergroten");
      main.appendChild(hint);
      main.setAttribute("title", TT("enlarge", "Vergroot foto"));
      gal.querySelectorAll(".g-sm").forEach(function (el) {
        el.classList.toggle("is-active", Number(el.getAttribute("data-i")) === i);
      });
    }

    function render(newList) {
      if (!newList.length) return;
      list = newList;
      gal.querySelectorAll(".g-sm").forEach(function (el) { el.remove(); });
      if (list.length > 1) {
        list.forEach(function (m, i) {
          var d = document.createElement("div");
          d.className = smClass;
          d.setAttribute("data-i", i);
          d.setAttribute("role", "button");
          d.setAttribute("tabindex", "0");
          d.setAttribute("aria-label", TT("show_photo", "Toon foto") + " " + (i + 1));
          d.appendChild(makeImg(m, false, false));
          gal.appendChild(d);
        });
      }
      setMain(0);
    }

    // Thumbnail -> large photo
    gal.addEventListener("click", function (e) {
      var t = e.target.closest(".g-sm");
      if (t && gal.contains(t)) {
        setMain(Number(t.getAttribute("data-i")));
        if (window.innerWidth < 900) main.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      // Large photo -> on-page zoom viewer
      if (e.target.closest(".g-main") && list[active]) openLb(active);
    });
    gal.addEventListener("keydown", function (e) {
      var t = e.target.closest && e.target.closest(".g-sm");
      if (t && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); setMain(Number(t.getAttribute("data-i"))); }
    });


    // ---------- On-page zoom viewer ----------
    var lb = document.createElement("div");
    lb.className = "tlr-lb";
    lb.setAttribute("role", "dialog");
    lb.setAttribute("aria-modal", "true");
    lb.setAttribute("aria-label", TT("lightbox", "Foto vergroot"));
    lb.innerHTML = '<button type="button" class="lb-x" aria-label="' + TT("close", "Sluiten") + '">&times;</button>' +
      '<button type="button" class="lb-p" aria-label="' + TT("prev", "Vorige foto") + '">&#8249;</button>' +
      '<button type="button" class="lb-n" aria-label="' + TT("next", "Volgende foto") + '">&#8250;</button>' +
      '<div class="tlr-lb-stage"><img alt=""></div><div class="lb-c"></div>';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector("img"), lbStage = lb.querySelector(".tlr-lb-stage"), lbCount = lb.querySelector(".lb-c");
    var lbIdx = 0, zoomed = false, scale = 2.5;

    function lbShow(i) {
      if (!list.length) return;
      lbIdx = (i + list.length) % list.length;
      unzoom();
      var m = list[lbIdx];
      lbImg.src = m.full || m.src;
      lbImg.alt = m.alt || "";
      lbCount.textContent = list.length > 1 ? (lbIdx + 1) + " / " + list.length + " · " + TT("zoom_in", "klik om in te zoomen") : TT("zoom_in", "klik om in te zoomen");
      lb.querySelector(".lb-p").style.visibility = list.length > 1 ? "" : "hidden";
      lb.querySelector(".lb-n").style.visibility = list.length > 1 ? "" : "hidden";
    }
    function openLb(i) {
      lbShow(i);
      lb.classList.add("open");
      document.documentElement.classList.add("tlr-lb-lock");
      lb.querySelector(".lb-x").focus();
    }
    function closeLb() {
      lb.classList.remove("open");
      document.documentElement.classList.remove("tlr-lb-lock");
      unzoom();
      if (lbIdx !== active) setMain(lbIdx);
    }
    function unzoom() { zoomed = false; lb.classList.remove("zoomed"); lbImg.style.transform = ""; }
    function pan(clientX, clientY) {
      var r = lbStage.getBoundingClientRect();
      var px = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
      var py = Math.min(1, Math.max(0, (clientY - r.top) / r.height));
      var iw = lbImg.offsetWidth * scale, ih = lbImg.offsetHeight * scale;
      var tx = Math.max(0, (iw - r.width) / 2) * (1 - 2 * px);
      var ty = Math.max(0, (ih - r.height) / 2) * (1 - 2 * py);
      lbImg.style.transform = "translate(" + tx + "px," + ty + "px) scale(" + scale + ")";
    }
    function toggleZoom(x, y) {
      if (zoomed) { unzoom(); return; }
      zoomed = true;
      lb.classList.add("zoomed");
      pan(x, y);
    }

    lb.addEventListener("click", function (e) {
      if (e.target.closest(".lb-x")) return closeLb();
      if (e.target.closest(".lb-p")) return lbShow(lbIdx - 1);
      if (e.target.closest(".lb-n")) return lbShow(lbIdx + 1);
      if (e.target === lbImg) { if (!moved) toggleZoom(e.clientX, e.clientY); return; }
      if (!zoomed) closeLb(); // click on the empty background closes
    });
    lb.addEventListener("mousemove", function (e) { if (zoomed) pan(e.clientX, e.clientY); });
    document.addEventListener("keydown", function (e) {
      if (!lb.classList.contains("open")) return;
      if (e.key === "Escape") closeLb();
      else if (e.key === "ArrowLeft") lbShow(lbIdx - 1);
      else if (e.key === "ArrowRight") lbShow(lbIdx + 1);
    });

    // Touch: swipe to change photo when not zoomed, drag to look around when zoomed
    var tx0 = 0, ty0 = 0, moved = false;
    lb.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) return;
      tx0 = e.touches[0].clientX; ty0 = e.touches[0].clientY; moved = false;
    }, { passive: true });
    lb.addEventListener("touchmove", function (e) {
      if (e.touches.length !== 1) return;
      var t = e.touches[0];
      if (Math.abs(t.clientX - tx0) > 8 || Math.abs(t.clientY - ty0) > 8) moved = true;
      if (zoomed) pan(t.clientX, t.clientY);
    }, { passive: true });
    lb.addEventListener("touchend", function (e) {
      if (zoomed || !moved) return;
      var t = e.changedTouches[0], dx = t.clientX - tx0, dy = t.clientY - ty0;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) lbShow(lbIdx + (dx < 0 ? 1 : -1));
      else if (dy > 80 && Math.abs(dy) > Math.abs(dx)) closeLb(); // swipe down closes
      setTimeout(function () { moved = false; }, 0);
    });

    var current = null;
    function showColour(colour) {
      var key = norm(colour);
      if (key === current) return;
      var l = (groups[key] || []).concat(shared);
      if (!l.length) return;
      current = key;
      render(l);
    }

    if (byColour) {
      root.addEventListener("change", function (e) {
        if (e.target && e.target.name === optName) showColour(e.target.value);
      });
      var checked = root.querySelector('input[name="' + optName + '"]:checked') || colourInputs[0];
      showColour(checked.value);
    } else {
      render(media); // single colour (e.g. Hotellijn): all photos, all clickable
    }
    gal.classList.add("is-ready");
  }
})();
